module.exports = __webpack_public_path__ + "static/media/tutorial3.ad0beb3e.png";